


import React, { useContext } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';

const CartItems = () => {
    const { getTotalCartAmount, all_product = [], cartItems, removeFromCart } = useContext(ShopContext);
    
    // Ensure `getTotalCartAmount()` does not fail
    const totalAmount = getTotalCartAmount ? getTotalCartAmount() : 0;

    return (
        <div className="cartitems">
            <div className="cartitems-format-main">
                <p>Products</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>
            <hr />

            {all_product
                .filter((product) => product && cartItems[product.id] > 0) // Ensure product is not undefined
                .map((product) => {
                    const price = product.new_price || 0; // Default to 0 if undefined

                    return (
                        <React.Fragment key={product.id}>
                            <div className="cartitems-format cartitems-format-main">
                                <img src={product.image} alt={product.name} className="carticon-product-icon" />
                                <p>{product.name}</p>
                                <p>₹{price}</p>
                                <button className="cartitems-quantity">{cartItems[product.id]}</button>
                                <p>₹{price * cartItems[product.id]}</p>
                                <img
                                    className="cartitems-remove-icon"
                                    src={remove_icon}
                                    onClick={() => removeFromCart(product.id)}
                                    alt="Remove"
                                />
                            </div>
                            <hr />
                        </React.Fragment>
                    );
                })}

            <div className="cartitems-down">
                <div className="cartitems-total">
                    <h1>Cart Totals</h1>
                    <div>
                        <div className="cartitems-total-item">
                            <p>Subtotal</p>
                            <p>₹{totalAmount}</p>
                        </div>
                        <hr />
                        <div className="cartitems-total-item">
                            <p>Shipping Fee</p>
                            <p>Free</p>
                        </div>
                        <hr />
                        <div className="cartitems-total-item">
                            <h3>Total</h3>
                            <h3>₹{totalAmount}</h3>
                        </div>
                        <button className='linkk'> <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSf8ZJpLJZ0o3WiiqpdUNEVFqHYXFWXnz1iaybmIn4UOMf82OQ/viewform?usp=header">PROCEED TO CHECKOUT</a></button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItems;
